const products_on_page = document.getElementById('product-grid');
let next_url = products_on_page.dataset.nextUrl;
const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];
const progress_bar = document.getElementById('progress-bar');
const current_products_span = document.getElementById('current-products');
const total_products_span = document.getElementById('total-products');

// Function to fetch the next page of products
async function getNextPage() {
    try {
        let res = await fetch(next_url);
        return await res.text();
    } catch (error) {
        console.log(error);
    }
}

// Function to load more products
async function loadMoreProducts() {
    if (!next_url) return; // Do nothing if there's no next URL

    load_more_btn.style.display = 'none';
    load_more_spinner.style.display = 'block';

    let nextPage = await getNextPage();
    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

    load_more_spinner.style.display = 'none';

    const productgrid = nextPageDoc.getElementById('product-grid');
    const new_products = productgrid.getElementsByClassName('grid__item');
    const new_url = productgrid.dataset.nextUrl;

    if (new_url) {
        load_more_btn.style.display = 'flex';
    }
    next_url = new_url;

    // Append the new products to the current product grid
    for (let i = 0; i < new_products.length; i++) {
        products_on_page.appendChild(new_products[i]);
    }

    // Update progress and current product count
    const new_current_products = products_on_page.getElementsByClassName('grid__item').length;
    const total_products = parseInt(total_products_span.innerText);

    const percentage_displayed = (new_current_products / total_products) * 100;

    progress_bar.style.width = `${percentage_displayed}%`;
    current_products_span.innerText = new_current_products;
}

// Listen for clicks on the "load more" button to load products
load_more_btn.addEventListener('click', loadMoreProducts);
